import { render, staticRenderFns } from "./TablePropertiesPanel.vue?vue&type=template&id=944322a4&scoped=true&lang=pug&"
import script from "./TablePropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./TablePropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./TablePropertiesPanel.vue?vue&type=style&index=0&id=944322a4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944322a4",
  null
  
)

/* custom blocks */
import block0 from "./TablePropertiesPanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports